import Relay from "react-relay"
import {
  RelayNetworkLayer,
  authMiddleware,
  urlMiddleware
  // loggerMiddleware,
} from "react-relay-network-layer"
import auth from "./auth"
import { isomorphicVars } from "./scripts/isomorphicVars"

export default function init(graphQLURL, headers = {}) {
  const {
    public_url: publicUrl,
    authentic_account_id: authenticAccountId
  } = isomorphicVars()

  Relay.injectNetworkLayer(
    new RelayNetworkLayer([
      authMiddleware({
        allowEmptyToken: true,
        token: () => auth.getAccessToken(),
        tokenRefreshPromise: () =>
          auth.refreshToken().catch(e => {
            console.log("graphql refresh token failed")
            auth.clearToken()
          })
      }),
      // loggerMiddleware(),
      urlMiddleware({
        url: () =>
          graphQLURL || (!publicUrl ? "/graphql" : publicUrl + "/graphql")
      }),
      next => req => {
        req.headers["authentic-account-id"] = authenticAccountId
        return next(req)
      }
    ])
  )
}



// WEBPACK FOOTER //
// ./webapp/relay.js